import { ReactNode } from 'react';

import { InputNumber, InputNumberProps, Space } from 'antd';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

interface CompactInputNumberProps extends Omit<InputNumberProps, 'addonAfter'> {
	addon: ReactNode;
}

export function CompactInputNumber({ addon, ...props }: CompactInputNumberProps) {
	return (
		<Space.Compact className={styles.fieldNumber} block>
			<InputNumber {...props} className={styles.fieldNumberInput} />
			<Space.Addon>{addon}</Space.Addon>
		</Space.Compact>
	);
}
